import { CancelToken } from 'axios';
import { CreatedUpdatedTable } from '../../utils/APIReturnTypes';
import AxiosConfig from '../../utils/AxiosConfig';

const axiosInstance = AxiosConfig.instance();

/*-------------------------------Broadcast-------------------------------------*/

export function getBroadcasts(last: number = 5, getFuture: boolean = false, token?: CancelToken): Promise<Broadcast[]> {
  var url = '/broadcasts';

  var config: any = {};
  if (token !== undefined) {
    config.cancelToken = token;
    config.params = { last, getFuture };
  }

  return axiosInstance.get(url, config).then((response) => response.data);
}

export function putBroadcast(broadcast: Broadcast): Promise<Broadcast> {
  var url = '/broadcasts';
  return axiosInstance.put(url, broadcast).then((response) => response.data);
}

export function deleteBroadcast(id: number): Promise<void> {
  var url = '/broadcasts/' + id;
  return axiosInstance.delete(url).then((response) => response.data);
}

export interface Broadcast extends CreatedUpdatedTable {
  id: number;
  title: string;
  message: string;
  version?: string;
  visibleDate?: Date;
}
